'use strict';

var React = require('react');

var SvgTabletMajor = function SvgTabletMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 1.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5v17a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-17zm2 .5h12v14h-12v-14zm6 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }));
};

exports.SvgTabletMajor = SvgTabletMajor;
